import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-identity-settings',
  templateUrl: './identity-settings.component.html',
  styleUrls: ['./identity-settings.component.scss']
})
export class IdentitySettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
